import { render, staticRenderFns } from "./student-list.vue?vue&type=template&id=0ed97cfd&"
import script from "./student-list.vue?vue&type=script&lang=ts&"
export * from "./student-list.vue?vue&type=script&lang=ts&"
import style0 from "./student-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports